import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import Strings from 'components/Strings';

import './helpDialog.css';

class HelpDialog extends React.Component {
  handleClose = () => {
    const { onClose } = this.props;
    onClose && onClose();
  }

  render() {
    const { fullScreen } = this.props;

    return (
      <Dialog
        className="HelpDialog"
        open
        onClose={ this.handleClose }
        aria-labelledby="form-dialog-title"
        key="form"
        fullScreen={ fullScreen }
      >
        <DialogTitle id="form-dialog-title"><Strings label="help_dialog_title" /></DialogTitle>
        <DialogContent>
          <Strings label="help_dialog_content" html />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={ this.handleClose }>
            <Strings label="close_button" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default HelpDialog;



// WEBPACK FOOTER //
// ./src/components/dialogs/HelpDialog/HelpDialog.js